import { parseRuntime } from './impl-helper';


let tradeTabPositionCache = -1;
window.FegoPostMessageToClient = function (functionName, postData) {
    const data = {
        func: functionName,
        data: postData
    };
    if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers['FTFegoNativeBridgeChannel'] &&
        window.webkit.messageHandlers['FTFegoNativeBridgeChannel'].postMessage
    ) {
        window.webkit.messageHandlers['FTFegoNativeBridgeChannel'].postMessage(data);
    } else {
        console.log('[err]FTFegoNativeBridgeChannel.postMessage 方法不存在');
    }
};

window.fegoNativeBridgeIOS = {
    getTradeTabPosition: function () {
        return new Promise((resolve) => {
            //添加超时处理
            setTimeout(() => {
                resolve(tradeTabPositionCache);
            }, 200);
            if (tradeTabPositionCache !== -1) {
                resolve(tradeTabPositionCache);
                return;
            }
            window.setTradeTabPosition = function (position) {
                tradeTabPositionCache = position;
                resolve(position);
            };
            window.FegoPostMessageToClient('getTradeTabPosition', {});
        });
    }
};

export const getTradeTabPositionFactRender = async (params, almanac) => {
    const { variable, current } = await parseRuntime(params, almanac);
    const isApp = variable?.IS_MOOMOO || variable?.IS_NN;
    let tradeTabPosition = tradeTabPositionCache;


    if (isApp && tradeTabPosition === -1) {
        // 先尝试直接取fegoNativeBridge,这个是安卓的，ios的是fegoNativeBridgeIOS
        // eslint-disable-next-line max-len
        if (window?.fegoNativeBridge?.getTradeTabPosition) {
            tradeTabPosition = await window?.fegoNativeBridge?.getTradeTabPosition();
        } else if (window?.fegoNativeBridgeIOS?.getTradeTabPosition) {
            tradeTabPosition = await window?.fegoNativeBridgeIOS?.getTradeTabPosition();
        }
    }

    if (current.port.id === 'is-lv1-port') {
        // 也不知道客户端可能是什么，先不严格判断了
        // eslint-disable-next-line eqeqeq
        return isApp && tradeTabPosition == 1;
    } else if (current.port.id === 'is-not-lv1-port') {
        // eslint-disable-next-line eqeqeq
        return !isApp || tradeTabPosition != 1;
    }
    return false;
};
